export default class MockContactsService {
  getPhoneInfo() {
    let promise = new Promise(resolve => {
      let wait = setTimeout(() => {
        clearTimeout(wait);
        resolve({ greenNumber: "33333", number: "55555" });
      }, 400);
    });

    return promise;
  }

  sendQuestion(question) {
    let promise = new Promise(resolve => {
      setTimeout(() => {
        resolve({
          error: false,
          question
        });
      }, 400);
    });

    return promise;

    // reject({
    //   error: true
    // });
  }
  prepareSuggestedAnswers(argsForSuggest) {
    let promise = new Promise(resolve => {
      let wait = setTimeout(() => {
        clearTimeout(wait);
        resolve(
          "this is a suggested answer [selections: object = " +
            argsForSuggest.object +
            " , topic = " +
            argsForSuggest.topic +
            "]"
        );
      }, 400);
    });
    return promise;
  }
}
